export default __webpack_public_path__ + "static/media/group_example.5d8d236a.pdf";